const finalPriceEl = document.querySelector('.purchase-process-01__final-price .final-price.title--h2');
const priceWithoutTaxEl = document.querySelector('.purchase-process-01__taxes .price-without-tax');
const priceTaxEl = document.querySelector('.purchase-process-01__taxes .price-tax');
const cartWrapEl = document.querySelector('.purchase-process-01');
const safeShoppingBanner = document.querySelector('.safe-shopping');
const cartEmptyWrapEl = document.querySelector('.purchase-process-01__empty');
const cartProducts = document.querySelector('.purchase-process-01__products');
let formData;
let promoData;

// Remove promo code
const updatePromoElsOnPromoRemove = (responseText, parent) => {
  const promoCodeSubmit = parent.querySelector('.promo-code__submit');
  const promoCodeInput = parent.querySelector('[name="promo"]');
  document.querySelector('.promo-code.promo-code--coupon:not(.is-active)').remove();
  promoCodeSubmit.disabled = false;
  parent.querySelector('.promo-code__discount').innerText = '';
  promoCodeInput.value = '';
  promoCodeInput.id = 'promo-';
  parent.querySelector('.promo-code__success').innerText = responseText;
  promoCodeSubmit.classList.remove('delete');
  parent.classList.remove('is-active');
  document.querySelector('.purchase-process-01__promo-codes').appendChild(parent)
};

// Update promo code elements
const updatePromoCodeElements = (responseArray) => {
  if (responseArray) {
    responseArray.forEach((coupon) => {
      const promoInputEl = cartWrapEl.querySelector(`.promo-code__inputs input#promo-${coupon.code}`);
      if (promoInputEl) {
        const parentEl = promoInputEl.closest('.promo-code--coupon');
        parentEl.querySelector('.promo-code__text').innerHTML = coupon.text;
        parentEl
          .querySelectorAll('.promo-code__inputs, .promo-code__success, .promo-code__discount')
          .forEach((el) => el.remove());
      }
    });
  }
};

// update total price
const updateTotalPrice = (e) => {
  let updatedTotalPrice = 0;
  document.querySelectorAll('.purchase-process-01__product:not(.is-hidden) .purchase-process-01__product-amount-price').forEach((item) => {
    updatedTotalPrice += parseFloat(item.dataset.price.replace(',', '.')) * parseFloat(item.querySelector('.amount').innerText);
  });
  setPriceInEuro(finalPriceEl, updatedTotalPrice);
};

const hideCartIfEmpty = () => {
  if (document.querySelectorAll('.purchase-process-01__product:not(.is-hidden):not(.cart__item--gift)').length < 1) {
    cartWrapEl.classList.add('hidden');
    cartEmptyWrapEl.classList.remove('hidden');
    safeShoppingBanner.remove();
    document.querySelectorAll('.purchase-process-01__product.cart__item--gift').forEach((el) => {
      el.classList.add('is-hidden');
    });
  }
};

const debounceAxios = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), timeout);
  };
};

const updatePricesAndCart = (data) => {
  finalPriceEl.innerText = data.total_price;
  finalPriceEl.dataset.discount = data.fixed_discount;
  priceWithoutTaxEl.innerText = data.total_price_without_tax;
  priceTaxEl.innerText = data.tax;
  cartProducts.innerHTML = data.cart_products_html;

  if (data.cross_sell_html) {
    cartWrapEl.querySelectorAll('.purchase-process-01__add-item-wrapper').forEach((item) => {
      item.innerHTML = data.cross_sell_html;
    });
  }
};

const axiosAddRemoveFromCart = (parent) => {
  parent.classList.add('pointer-events-none');
  const formDataInput = new FormData();
  formDataInput.append('action', 'addRemoveFromCart');
  formDataInput.append('inputs', JSON.stringify(formData));
  formDataInput.append('id', localData.id);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        updatePricesAndCart(response.data.data);
        updatePromoCodeElements(response.data.data.removed_coupons);
        updateCartQuantityBadge();
        parent.classList.remove('pointer-events-none');
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const axiosRemoveItemFromCart = (itemKey, parent) => {
  parent.classList.add('pointer-events-none');
  const formDataInput = new FormData();
  formDataInput.append('action', 'removeItemFromCart');
  formDataInput.append('item_key', itemKey);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        updatePricesAndCart(response.data.data);
        updatePromoCodeElements(response.data.data.removed_coupons);
        updateCartQuantityBadge();
        parent.classList.remove('pointer-events-none');
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

const axiosAddCrossSell = (crossSellData, parent) => {
  parent.classList.add('pointer-events-none');
  const formDataInput = new FormData();
  formDataInput.append('action', 'addCrossSell');
  formDataInput.append('inputs', JSON.stringify(crossSellData));
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        updatePricesAndCart(response.data.data);
        updateCartQuantityBadge();
        parent.classList.remove('pointer-events-none');
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
const addRemoveItem = (element, increment) => {
  const parentElem = element.closest('.purchase-process-01__product-amount-price');
  const itemPrice = parentElem.querySelector('.purchase-process-01__product-price .title--h3');
  const amount = parentElem.querySelector('.amount');
  const dataItemPrice = parentElem.dataset.price.replace(',', '.');
  const currentAmount = parseInt(amount.innerText, 10);

  if (!increment && currentAmount === 1) {
    return;
  }

  const newAmount = increment ? currentAmount + 1 : currentAmount - 1;
  formData = {
    cart_item_key: parentElem.dataset.itemkey,
    quantity: newAmount,
    old_quantity: currentAmount,
    price: dataItemPrice,
  };

  amount.innerText = newAmount;
  parentElem.dataset.quantity = newAmount.toString();
  if (parentElem.hasAttribute('data-regularprice')) {
    const regularPrice = parentElem.dataset.regularprice;
    itemPrice.innerHTML = `<s>${getPriceInEuro(parseFloat(regularPrice) * parseFloat(amount.innerText))}</s>${getPriceInEuro(
      parseFloat(dataItemPrice) * parseFloat(amount.innerText),
    )}`;
  } else {
    setPriceInEuro(itemPrice, parseFloat(amount.innerText) * parseFloat(dataItemPrice));
  }
};

const debounceAxiosAddRemoveFromCart = debounceAxios((parent) => axiosAddRemoveFromCart(parent));

const removeFromCart = (element) => {
  const parentProductListElem = element.closest('.purchase-process-01__products');
  const parentElem = element.closest('.purchase-process-01__product');
  const priceElem = parentElem.querySelector('.purchase-process-01__product-amount-price');
  parentElem.remove();
  hideCartIfEmpty();
  axiosRemoveItemFromCart(priceElem.dataset.itemkey, parentProductListElem);
};

attachEvent('.purchase-process-01__add-item .purchase-process-01__add-item__delete', 'click', (ev) => {
  const parentCrossListElem = ev.target.closest('.purchase-process-01__add-item-wrapper');
  const crossSellItem = ev.target.closest('.purchase-process-01__add-item');
  const { productid, variationid } = crossSellItem.dataset;
  axiosAddCrossSell({
    productid,
    variationid
  }, parentCrossListElem);
  crossSellItem.remove();
  if (document.querySelectorAll('.purchase-process-01__right .purchase-process-01__add-item').length < 1) {
    document.querySelector('.purchase-process-01__right .purchase-process-01__right-title').classList.add('is-hidden');
  }
});

attachEvent('.purchase-process-01__product .purchase-process-01__product-delete', 'click', (ev) => {
  removeFromCart(ev.target);
});

attachEvent('.purchase-process-01__product .more', 'click', (ev) => {
  addRemoveItem(ev.target, true);
  debounceAxiosAddRemoveFromCart(ev.target.closest('.purchase-process-01__products'));
});

attachEvent('.purchase-process-01__product .less', 'click', (ev) => {
  addRemoveItem(ev.target, false);
  debounceAxiosAddRemoveFromCart(ev.target.closest('.purchase-process-01__products'));
});

attachEvent('.purchase-process-01__product-save', 'click', (ev) => {
  ev.preventDefault();
  const axiosData = new FormData();
  axiosData.append('action', 'toggleItemOnLikedList');
  axiosData.append('productid', ev.target.closest('.purchase-process-01__product').dataset.productid);
  axios
    .post(localData.siteURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // eslint-disable-next-line no-param-reassign
        ev.target.style.display = 'none';
        updateWishListQuantityBadge();
      }
    });
});

// Add Promo Code
const axiosAddPromoCode = (parentPromoCodeEl) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'addPromoCode');
  formDataInput.append('inputs', JSON.stringify(promoData));
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        parentPromoCodeEl.querySelector('.promo-code__submit').disabled = false;
        if (response.data.data.promo_valid) {
          parentPromoCodeEl.querySelector('.promo-code__submit').classList.add('delete');
          parentPromoCodeEl.classList.add('is-active', 'is-success');
          parentPromoCodeEl.querySelector('.promo-code__success').innerText = response.data.data.response_text;
          parentPromoCodeEl.querySelector('.promo-code__discount').innerText = response.data.data.coupon_amount;
          parentPromoCodeEl.querySelector('.promo-code__error').innerText = '';
          parentPromoCodeEl.querySelector('.promo-code__inputs input').id = response.data.data.coupon_id;
          updatePricesAndCart(response.data.data);

          if (response.data.data.coupon_html) {
            document.querySelector('.purchase-process-01__promo-codes').insertAdjacentHTML('beforeend', response.data.data.coupon_html);
          }
          updateCartQuantityBadge();
        } else {
          parentPromoCodeEl.classList.add('is-error');
          parentPromoCodeEl.querySelector('.promo-code__error').innerText = response.data.data.response_text;
          parentPromoCodeEl.querySelector('.promo-code__success').innerText = '';
        }
      }
    })
    .catch((err) => {
      console.error(err);
    });
};

// Remove Promo Code
const axiosRemovePromoCode = (parent, input) => {
  const formDataInput = new FormData();
  formDataInput.append('action', 'removePromoCode');
  formDataInput.append('input', input);
  axios
    .post(localData.siteURL, formDataInput, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        // success
        updatePromoElsOnPromoRemove(response.data.data.response_text, parent);
        updatePricesAndCart(response.data.data);
        updateCartQuantityBadge();
      }
    })
    .catch((err) => {
      console.error(err);
    });
};
attachEvent('.promo-code--coupon .promo-code__submit:not(.delete)', 'click', (ev) => {
  const parentPromoCodeEl = ev.target.closest('.promo-code');
  const promoCodeInput = parentPromoCodeEl.querySelector('[name="promo"]').value.replace(/(<([^>]+)>)/gi, '');
  const inputEmpty = promoCodeInput.length < 1;
  const inputInvalid = !/^[a-zA-Z0-9/\-+=#]+$/.test(promoCodeInput);
  let cartItemsWithDiscount = 0;
  if (inputEmpty || inputInvalid) {
    parentPromoCodeEl.classList.add('is-error');
    parentPromoCodeEl.querySelector('.promo-code__error').innerText = inputEmpty ? 'Vnesite promo kodo' : 'Vnesite veljavno promo kodo';
  } else {
    const cartItems = document.querySelectorAll('.purchase-process-01__product:not(.is-hidden)');
    cartItems.forEach((item) => {
      if (item.querySelector('.purchase-process-01__product-amount-price').hasAttribute('data-regularprice')) {
        cartItemsWithDiscount += 1;
      }
    });
    promoData = promoCodeInput;
    promoData = {
      code: promoCodeInput,
      all_items_have_discount: cartItems.length === cartItemsWithDiscount,
    };
    parentPromoCodeEl.querySelector('.promo-code__submit').disabled = true;
    axiosAddPromoCode(parentPromoCodeEl);
  }
});

attachEvent('.promo-code--coupon .promo-code__submit.delete', 'click', (ev) => {
  const parentPromoCodeEl = ev.target.closest('.promo-code')
  const promoCodeInput = parentPromoCodeEl.querySelector('[name="promo"]').value.replace(/(<([^>]+)>)/gi, '');
  const inputEmpty = promoCodeInput.length < 1;
  const inputInvalid = !/^[a-zA-Z0-9/\-+=#]+$/.test(promoCodeInput);

  if (inputEmpty || inputInvalid) {
    parentPromoCodeEl.classList.add('is-error');
    parentPromoCodeEl.querySelector('.promo-code__error').innerText = inputEmpty ? 'Vnesite promo kodo' : 'Vnesite veljavno promo kodo';
    return;
  }

  parentPromoCodeEl.querySelector('.promo-code__submit').disabled = true;
  axiosRemovePromoCode(parentPromoCodeEl, promoCodeInput);
});
